import React from 'react';
import PropTypes from 'prop-types';

function Full({ color, ...rest }) {
  return (
    <svg viewBox="0 0 475 76" height="76" {...rest}>
      <g id="agencyminder">
        <path
          fill={color}
          d="M94 38.473C94 30.487 99.603 24 108.037 24c3.792 0 7.47 1.276 10.13 4.99v-2.385c0-1.271.793-1.994 2.096-1.994h1.696c1.303 0 2.041.723 2.041 1.994v23.79c0 1.276-.738 1.996-2.041 1.996h-1.696c-1.303 0-2.096-.72-2.096-1.996V48.01c-2.66 3.713-6.338 4.989-10.13 4.989C99.603 53 94 46.457 94 38.473m24.281 0c-.055-5.487-3.847-9.536-9.45-9.536-5.72 0-9.003 4.38-9.003 9.536 0 5.21 3.284 9.538 9.003 9.538 5.603 0 9.395-4.05 9.45-9.538M132.302 63.077c-1.018-.675-1.188-1.685-.624-2.81l.454-.789c.624-1.294 1.582-1.402 2.774-.673 2.432 1.518 5.206 2.19 8.094 2.19 5.434 0 9.167-3.09 9.167-9.05v-3.6c-2.66 3.769-6.338 5.062-10.13 5.062-8.493 0-14.037-6.637-14.037-14.731C128 30.638 133.544 24 142.037 24c3.792 0 7.47 1.294 10.13 5.062v-2.475c0-1.234.793-1.966 2.096-1.966h1.642c1.302 0 2.095.732 2.095 2.021V52.34c0 9.557-7.076 13.66-14.945 13.66-4.925 0-8.149-1.238-10.753-2.923m19.98-24.401c-.055-5.566-3.848-9.67-9.451-9.67-5.72 0-9.001 4.44-9.001 9.67 0 5.284 3.282 9.67 9 9.67 5.604 0 9.397-4.103 9.453-9.67M162 38.583C162 30.486 168.292 24 176.904 24c6.954 0 13.302 4.16 14.074 13.029.166 1.33-.607 2.053-1.932 2.053h-21.417c-.165 5.155 4.084 8.926 10.103 8.926 2.705 0 5.134-.718 7.508-2.328 1.047-.662 1.932-.611 2.813.274l.385.445c.886.945.886 2.106-.385 3.163-3.202 2.605-6.9 3.438-10.379 3.438C167.961 53 162 46.513 162 38.583zm23.348-3.713c-1.436-4.936-5.299-5.988-8.336-5.988-3.2 0-7.173 1.272-8.885 5.988h17.221zM197 50.961v-24.3c0-1.298.755-2.035 2-2.035h1.625c1.241 0 1.947.737 1.947 2.035v3.516c1.19-3.965 4.653-6.177 9.037-6.177C217.616 24 222 28.081 222 36.971v13.99c0 1.304-.754 2.039-2 2.039h-1.625c-1.245 0-1.947-.735-1.947-2.039V37.027c0-5.831-2.543-7.93-5.41-7.93-2.816 0-8.446 1.983-8.446 10.591v11.273c0 1.304-.706 2.039-1.947 2.039H199c-1.244 0-1.999-.735-1.999-2.039M227 38.806C227 30.657 232.594 24 242.612 24c2.217 0 5.203.444 8.361 2.272 1.161.664 1.327 1.774.551 2.83l-.44.553c-.775 1.056-1.605 1.11-2.824.557-2.382-1.165-4.76-1.22-5.369-1.22-5.87 0-10.186 3.88-10.186 9.482 0 5.599 4.316 9.537 10.186 9.537.609 0 2.987-.056 5.369-1.22 1.219-.61 2.103-.5 2.825.554l.385.552c.776 1.057.387 2.384-1.384 3.275-2.768 1.496-5.482 1.828-7.474 1.828C232.813 53 227 46.734 227 38.806M260.478 61.684l4.193-11.09-10.45-24.278c-.599-1.378.054-2.316 1.521-2.316h2.179c1.142 0 1.851.497 2.232 1.546l7.566 18.7 6.966-18.646c.378-1.103 1.194-1.6 2.341-1.6h2.23c1.469 0 2.122.883 1.522 2.316l-15.185 36.14c-.432 1.103-1.141 1.544-2.285 1.544h-1.304c-1.473 0-2.07-.942-1.526-2.316M298 50.961v-24.3c0-1.298.772-2.035 2.04-2.035h1.648c1.268 0 1.98.737 1.98 2.035v3.516c1.16-4.08 4.684-6.177 8.704-6.177 2.698 0 6.605.911 8.698 5.836 2.31-4.871 6.057-5.836 9.359-5.836C336.98 24 341 28.081 341 36.971v13.99c0 1.304-.714 2.039-1.98 2.039h-1.651c-1.268 0-2.038-.735-2.038-2.039v-13.99c0-5.775-2.535-7.873-5.452-7.873-2.533 0-7.266 1.644-7.543 9.97v11.893c0 1.304-.718 2.039-1.98 2.039H318.7c-1.265 0-2.034-.735-2.034-2.039v-13.99c0-5.775-2.533-7.873-5.45-7.873-2.81 0-7.548 1.982-7.548 10.59v11.273c0 1.304-.713 2.039-1.98 2.039h-1.65c-1.267 0-2.039-.735-2.039-2.039M347 15.836c0-2.134 1.45-3.836 3.45-3.836 2.05 0 3.55 1.702 3.55 3.836 0 2.08-1.548 3.73-3.55 3.73-2 0-3.45-1.65-3.45-3.73m.902 34.193V26.522c0-1.258.698-1.972 1.848-1.972h1.503c1.147 0 1.799.714 1.799 1.972V50.03c0 1.262-.652 1.971-1.799 1.971h-1.503c-1.15 0-1.848-.71-1.848-1.97M361 50.961v-24.3c0-1.298.755-2.035 2-2.035h1.625c1.243 0 1.947.737 1.947 2.035v3.516c1.19-3.965 4.653-6.177 9.037-6.177C381.616 24 386 28.081 386 36.971v13.99c0 1.304-.754 2.039-2 2.039h-1.625c-1.245 0-1.947-.735-1.947-2.039V37.027c0-5.831-2.543-7.93-5.41-7.93-2.816 0-8.446 1.983-8.446 10.591v11.273c0 1.304-.704 2.039-1.947 2.039H363c-1.244 0-1.999-.735-1.999-2.039M391 37.722c0-7.85 5.603-14.226 14.037-14.226 3.792 0 7.474 1.255 10.133 4.906v-14.44c0-1.253.794-1.962 2.093-1.962h1.701c1.301 0 2.036.709 2.036 1.962v35.477c0 1.255-.735 1.962-2.036 1.962h-1.7c-1.3 0-2.094-.707-2.094-1.962v-2.343c-2.66 3.65-6.34 4.904-10.133 4.904C396.603 52 391 45.569 391 37.722m24.281 0c-.055-5.393-3.847-9.374-9.45-9.374-5.72 0-9.003 4.305-9.003 9.374 0 5.121 3.284 9.374 9.003 9.374 5.603 0 9.395-3.98 9.45-9.374M425 38.583C425 30.486 431.29 24 439.902 24c6.953 0 13.302 4.16 14.076 13.029.165 1.33-.608 2.053-1.931 2.053H430.63c-.167 5.155 4.085 8.926 10.1 8.926 2.706 0 5.132-.718 7.507-2.328 1.051-.662 1.93-.611 2.817.274l.384.445c.882.945.882 2.106-.384 3.163-3.202 2.605-6.9 3.438-10.379 3.438C430.96 53 425 46.513 425 38.583zm23.348-3.713c-1.434-4.936-5.298-5.988-8.333-5.988-3.202 0-7.177 1.272-8.89 5.988h17.223z"
        />
        <g transform="translate(458 24)">
          <path
            fill={color}
            d="M.758 26.444V2.86c0-1.26.78-1.975 2.06-1.975h1.67c1.282 0 2.003.715 2.003 1.975v4.182c.948-4.4 4.122-6.765 7.461-6.765l1.227.059c1.168.164 1.335 1.098 1.335 2.195v1.594c0 1.377-.554 1.925-1.503 1.706a6.924 6.924 0 0 0-1.5-.165c-2.009 0-7.02.989-7.02 12.258v8.519c0 1.265-.721 1.978-2.003 1.978h-1.67c-1.28 0-2.06-.713-2.06-1.978"
          />
        </g>
      </g>
      <g id="mark">
        <path
          fill="#F8A01B"
          d="M18.56 64.302c-7.025-4.916-11.974-12.58-13.23-21.427A1.01 1.01 0 0 0 4.318 42l-3.313.036c-.601.007-1.073.528-.997 1.12 1.374 10.64 7.317 19.859 15.794 25.67.485.334 1.157.17 1.447-.342l1.621-2.863a1 1 0 0 0-.31-1.319"
        />
        <path
          fill="#EC333E"
          d="M38.684 70.9a33.715 33.715 0 0 1-11.641-1.93c-.476-.169-1.01.007-1.259.426l-1.65 2.78a.944.944 0 0 0 .504 1.374c4.37 1.625 9.13 2.5 14.107 2.448a39.118 39.118 0 0 0 15.682-3.434.944.944 0 0 0 .429-1.368l-1.706-2.725c-.27-.431-.84-.588-1.32-.379A33.554 33.554 0 0 1 38.683 70.9M69.4 41.96c-1.04 8.53-5.495 16.07-12.003 21.274-.408.327-.52.888-.25 1.33l1.78 2.926a1.08 1.08 0 0 0 1.569.29c7.957-6.18 13.373-15.31 14.498-25.65.066-.613-.441-1.137-1.073-1.13l-3.48.036a1.057 1.057 0 0 0-1.042.924"
        />
        <g transform="translate(21)">
          <mask id="d" fill="#fff">
            <path id="c" d="M.488.158h31.314V7.97H.488z" />
          </mask>
          <path
            fill="#F3EF5D"
            d="M15.357 5.304a33.67 33.67 0 0 1 13.342 2.58c.488.204 1.06.034 1.32-.41l1.65-2.785a.95.95 0 0 0-.46-1.365A39.296 39.296 0 0 0 15.295.16a39.288 39.288 0 0 0-14.19 2.796.956.956 0 0 0-.473 1.397L2.358 7.12c.26.417.802.584 1.277.401a33.686 33.686 0 0 1 11.722-2.217"
            mask="url(#d)"
          />
        </g>
        <g transform="translate(0 7)">
          <mask id="f" fill="#fff">
            <path id="e" d="M0 .455h18.75v28.428H0z" />
          </mask>
          <path
            fill="#F8A01B"
            d="M5.419 27.91A32.93 32.93 0 0 1 18.325 5.276c.428-.32.554-.91.283-1.371L16.895.97a1.017 1.017 0 0 0-1.48-.32A38.422 38.422 0 0 0 .005 27.748a1.033 1.033 0 0 0 1.038 1.134l3.368-.037a1.034 1.034 0 0 0 1.008-.937"
            mask="url(#f)"
          />
        </g>
        <path
          id="plusSymbol"
          fill={color}
          d="M76 26.368l-.045-4.034a1.084 1.084 0 0 0-1.095-1.072l-9.293.103-.104-9.293A1.084 1.084 0 0 0 64.368 11l-4.036.045a1.084 1.084 0 0 0-1.07 1.097l.103 9.291-9.293.104A1.085 1.085 0 0 0 49 22.634l.045 4.034a1.085 1.085 0 0 0 1.095 1.072l9.293-.104.104 9.292c.006.6.497 1.079 1.095 1.072l4.036-.045a1.084 1.084 0 0 0 1.072-1.095l-.104-9.293 9.292-.104A1.083 1.083 0 0 0 76 26.368"
        />
      </g>
    </svg>
  );
}

function Type({ color, ...rest }) {
  return (
    <svg viewBox="0 0 380 54" {...rest}>
      <g id="Type" fill={color}>
        <path
          d="M82.9,12C74.29,12,68,18.49,68,26.58C68,34.51,73.96,41,83.67,41c3.48,0,7.18-0.83,10.38-3.44
		c1.27-1.06,1.27-2.22,0.39-3.16l-0.39-0.45c-0.88-0.89-1.77-0.94-2.81-0.27c-2.37,1.61-4.8,2.33-7.51,2.33
		c-6.02,0-10.27-3.77-10.1-8.93h21.42c1.33,0,2.1-0.72,1.93-2.05C96.21,16.16,89.86,12,82.9,12z M74.13,22.87
		c1.71-4.72,5.68-5.99,8.89-5.99c3.04,0,6.9,1.05,8.34,5.99H74.13z"
        />
        <path
          d="M148.89,16.99c0.61,0,2.99,0.05,5.37,1.22c1.22,0.55,2.05,0.5,2.82-0.56l0.44-0.55
		c0.78-1.06,0.61-2.17-0.55-2.83c-3.16-1.83-6.14-2.27-8.36-2.27C138.59,12,133,18.66,133,26.81c0,7.93,5.81,14.19,15.61,14.19
		c1.99,0,4.71-0.33,7.47-1.83c1.77-0.89,2.16-2.22,1.38-3.28l-0.39-0.55c-0.72-1.05-1.61-1.16-2.82-0.55
		c-2.38,1.16-4.76,1.22-5.37,1.22c-5.87,0-10.19-3.94-10.19-9.54C138.7,20.87,143.02,16.99,148.89,16.99z"
        />
        <path
          d="M117.61,12c-4.38,0-7.85,2.21-9.04,6.18v-3.52c0-1.3-0.71-2.04-1.95-2.04H105c-1.24,0-2,0.74-2,2.04v24.3h0
		c0,1.3,0.75,2.04,2,2.04h1.62c1.24,0,1.95-0.73,1.95-2.04V27.69c0-8.61,5.63-10.59,8.45-10.59c2.87,0,5.41,2.1,5.41,7.93v13.93
		c0,1.3,0.7,2.04,1.95,2.04H126c1.25,0,2-0.73,2-2.04V24.97C128,16.08,123.62,12,117.61,12z"
        />
        <path
          d="M61.91,12.62h-1.64c-1.3,0-2.1,0.73-2.1,1.97v2.48C55.51,13.29,51.83,12,48.04,12C39.54,12,34,18.64,34,26.68
		c0,8.09,5.54,14.73,14.04,14.73c3.79,0,7.47-1.29,10.13-5.06v3.6c0,5.96-3.73,9.05-9.17,9.05c-2.89,0-5.66-0.67-8.09-2.19
		c-1.19-0.73-2.15-0.62-2.77,0.67l-0.45,0.79c-0.56,1.12-0.39,2.14,0.62,2.81c2.6,1.68,5.83,2.92,10.75,2.92
		C56.92,54,64,49.9,64,40.34v-25.7C64,13.35,63.21,12.62,61.91,12.62z M48.83,36.35c-5.72,0-9-4.39-9-9.67c0-5.23,3.28-9.67,9-9.67
		c5.6,0,9.4,4.1,9.45,9.67h0C58.23,32.24,54.43,36.35,48.83,36.35z"
        />
        <path
          d="M27.96,12.61h-1.7c-1.3,0-2.1,0.72-2.1,1.99v2.39C21.51,13.28,17.83,12,14.04,12C5.6,12,0,18.49,0,26.47
		C0,34.46,5.6,41,14.04,41c3.79,0,7.47-1.28,10.13-4.99v2.39c0,1.28,0.79,2,2.1,2h1.7c1.3,0,2.04-0.72,2.04-2V14.6
		C30,13.33,29.26,12.61,27.96,12.61z M14.83,36.01c-5.72,0-9-4.33-9-9.54c0-5.16,3.28-9.54,9-9.54c5.6,0,9.4,4.05,9.45,9.54
		C24.23,31.96,20.43,36.01,14.83,36.01z"
        />
        <path
          d="M257.25,12.55h-1.5c-1.15,0-1.85,0.71-1.85,1.97v23.51v0c0,1.26,0.7,1.97,1.85,1.97h1.5
		c1.15,0,1.8-0.71,1.8-1.97V14.52C259.05,13.26,258.4,12.55,257.25,12.55z"
        />
        <path
          d="M281.61,12c-4.38,0-7.85,2.21-9.04,6.18v-3.52c0-1.3-0.7-2.04-1.95-2.04H269c-1.24,0-2,0.74-2,2.04v24.3h0
		c0,1.3,0.76,2.04,2,2.04h1.62c1.24,0,1.95-0.73,1.95-2.04V27.69c0-8.61,5.63-10.59,8.45-10.59c2.87,0,5.41,2.1,5.41,7.93v13.93
		c0,1.3,0.7,2.04,1.95,2.04H290c1.25,0,2-0.73,2-2.04V24.97C292,16.08,287.62,12,281.61,12z"
        />
        <path
          d="M324.96,0h-1.7c-1.3,0-2.09,0.71-2.09,1.96V16.4c-2.66-3.65-6.34-4.91-10.13-4.91
		c-8.43,0-14.04,6.38-14.04,14.23c0,7.85,5.6,14.28,14.04,14.28c3.79,0,7.47-1.25,10.13-4.9v2.34c0,1.26,0.79,1.96,2.09,1.96h1.7
		c1.3,0,2.04-0.71,2.04-1.96V1.96C327,0.71,326.26,0,324.96,0z M311.83,35.1c-5.72,0-9-4.25-9-9.37c0-5.07,3.28-9.37,9-9.37
		c5.6,0,9.4,3.98,9.45,9.37C321.23,31.12,317.43,35.1,311.83,35.1z"
        />
        <path
          d="M345.9,12c-8.61,0-14.9,6.49-14.9,14.58c0,7.93,5.96,14.42,15.67,14.42c3.48,0,7.18-0.83,10.38-3.44
		c1.27-1.06,1.27-2.22,0.38-3.16l-0.38-0.45c-0.89-0.89-1.77-0.94-2.82-0.27c-2.38,1.61-4.8,2.33-7.51,2.33
		c-6.02,0-10.27-3.77-10.1-8.93h21.42c1.32,0,2.1-0.72,1.93-2.05C359.2,16.16,352.86,12,345.9,12z M354.35,22.87h-17.22
		c1.71-4.72,5.69-5.99,8.89-5.99C349.05,16.88,352.91,17.93,354.35,22.87L354.35,22.87z"
        />
        <path
          d="M236.43,12c-3.3,0-7.05,0.97-9.36,5.84c-2.09-4.92-6-5.84-8.7-5.84c-4.02,0-7.54,2.1-8.7,6.18v-3.52
		c0-1.3-0.71-2.04-1.98-2.04h-1.65c-1.27,0-2.04,0.74-2.04,2.04v24.3h0c0,1.3,0.77,2.04,2.04,2.04h1.65c1.27,0,1.98-0.73,1.98-2.04
		V27.69c0-8.61,4.74-10.59,7.55-10.59c2.92,0,5.45,2.1,5.45,7.87v13.99c0,1.3,0.77,2.04,2.03,2.04h1.66c1.26,0,1.98-0.73,1.98-2.04
		V27.07c0.28-8.33,5.01-9.97,7.54-9.97c2.92,0,5.45,2.1,5.45,7.87v13.99c0,1.3,0.77,2.04,2.04,2.04h1.65c1.27,0,1.98-0.73,1.98-2.04
		V24.97C247,16.08,242.98,12,236.43,12z"
        />
        <path
          d="M256.45,0c-2,0-3.45,1.7-3.45,3.84c0,2.08,1.45,3.73,3.45,3.73c2,0,3.55-1.65,3.55-3.73
		C260,1.7,258.5,0,256.45,0z"
        />
        <path
          class="st0"
          d="M185.26,12h-2.23c-1.15,0-1.96,0.5-2.34,1.6l-6.97,18.65l-7.57-18.7c-0.38-1.05-1.09-1.55-2.23-1.55h-2.18
		c-1.47,0-2.12,0.94-1.52,2.32l10.45,24.28l-4.19,11.09C165.93,51.06,166.53,52,168,52h1.3c1.14,0,1.85-0.44,2.28-1.54l15.18-36.14
		C187.38,12.88,186.73,12,185.26,12z"
        />
        <path
          d="M379.18,12.34l-1.23-0.06c-3.34,0-6.51,2.37-7.46,6.77v-4.18c0-1.26-0.72-1.97-2-1.97h-1.67
		c-1.28,0-2.06,0.71-2.06,1.97v23.58c0,1.27,0.78,1.98,2.06,1.98h1.67c1.28,0,2-0.71,2-1.98v-8.52c0-11.27,5.01-12.26,7.02-12.26
		c0.5,0,1.01,0.06,1.5,0.16c0.95,0.22,1.5-0.33,1.5-1.71v-1.59C380.51,13.43,380.35,12.5,379.18,12.34z"
        />
      </g>
    </svg>
  );
}

function Mark({ color, ...rest }) {
  return (
    <svg viewBox="0 0 76 76" {...rest}>
      <path
        fill="#F8A01B"
        d="M18.56 64.302c-7.025-4.916-11.974-12.58-13.23-21.427A1.01 1.01 0 0 0 4.318 42l-3.313.036c-.601.007-1.073.528-.997 1.12 1.374 10.64 7.317 19.859 15.794 25.67.485.334 1.157.17 1.447-.342l1.621-2.863a1 1 0 0 0-.31-1.319"
      />
      <path
        fill="#EC333E"
        d="M38.684 70.9a33.715 33.715 0 0 1-11.641-1.93c-.476-.169-1.01.007-1.259.426l-1.65 2.78a.944.944 0 0 0 .504 1.374c4.37 1.625 9.13 2.5 14.107 2.448a39.118 39.118 0 0 0 15.682-3.434.944.944 0 0 0 .429-1.368l-1.706-2.725c-.27-.431-.84-.588-1.32-.379A33.554 33.554 0 0 1 38.683 70.9M69.4 41.96c-1.04 8.53-5.495 16.07-12.003 21.274-.408.327-.52.888-.25 1.33l1.78 2.926a1.08 1.08 0 0 0 1.569.29c7.957-6.18 13.373-15.31 14.498-25.65.066-.613-.441-1.137-1.073-1.13l-3.48.036a1.057 1.057 0 0 0-1.042.924"
      />
      <g transform="translate(21)">
        <mask id="d" fill="#fff">
          <path id="c" d="M.488.158h31.314V7.97H.488z" />
        </mask>
        <path
          fill="#F3EF5D"
          d="M15.357 5.304a33.67 33.67 0 0 1 13.342 2.58c.488.204 1.06.034 1.32-.41l1.65-2.785a.95.95 0 0 0-.46-1.365A39.296 39.296 0 0 0 15.295.16a39.288 39.288 0 0 0-14.19 2.796.956.956 0 0 0-.473 1.397L2.358 7.12c.26.417.802.584 1.277.401a33.686 33.686 0 0 1 11.722-2.217"
          mask="url(#d)"
        />
      </g>
      <g transform="translate(0 7)">
        <mask id="f" fill="#fff">
          <path id="e" d="M0 .455h18.75v28.428H0z" />
        </mask>
        <path
          fill="#F8A01B"
          d="M5.419 27.91A32.93 32.93 0 0 1 18.325 5.276c.428-.32.554-.91.283-1.371L16.895.97a1.017 1.017 0 0 0-1.48-.32A38.422 38.422 0 0 0 .005 27.748a1.033 1.033 0 0 0 1.038 1.134l3.368-.037a1.034 1.034 0 0 0 1.008-.937"
          mask="url(#f)"
        />
      </g>
      <path
        id="plusSymbol"
        fill={color}
        d="M76 26.368l-.045-4.034a1.084 1.084 0 0 0-1.095-1.072l-9.293.103-.104-9.293A1.084 1.084 0 0 0 64.368 11l-4.036.045a1.084 1.084 0 0 0-1.07 1.097l.103 9.291-9.293.104A1.085 1.085 0 0 0 49 22.634l.045 4.034a1.085 1.085 0 0 0 1.095 1.072l9.293-.104.104 9.292c.006.6.497 1.079 1.095 1.072l4.036-.045a1.084 1.084 0 0 0 1.072-1.095l-.104-9.293 9.292-.104A1.083 1.083 0 0 0 76 26.368"
      />
    </svg>
  );
}

const Logo = ({ variant, ...rest }) => {
  switch (variant) {
    case 'full':
      return <Full {...rest} />;
    case 'mark':
      return <Mark {...rest} />;
    case 'type':
      return <Type {...rest} />;
    default:
      throw new Error('Logo variant not matched');
  }
};

Logo.propTypes = {
  variant: PropTypes.oneOf(['full', 'mark', 'type']),
  color: PropTypes.string,
};

Logo.defaultProps = {
  variant: 'full',
  color: '#181032',
};

export default Logo;
